export default {
  informationInverseColor: 'brandOne80',
  borderRadius: 'medium',
  includeBorder: false,
  displayDirection: 'row',
  defaultBorderColor: 'systemInformation20',
};
